import { useReducedMotion } from 'framer-motion'
import { TrendingUp } from 'lucide-react'
import {
  Bar,
  BarChart,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts'
import {
  buildCaptacaoTrendData,
  hasCaptacaoTrendData,
  type CaptacaoTabView,
} from '@/components/Dashboard/captacaoTab.utils'
import { formatDashboardNumber } from '@/utils/crmValuesDisplay'

type Props = {
  view: CaptacaoTabView
  valuesVisible?: boolean
}

export function CaptacaoTrendChart({ view, valuesVisible = false }: Props) {
  const reduced = useReducedMotion()
  const chartData = buildCaptacaoTrendData(view.leadsCreatedByMonth)
  const hasData = hasCaptacaoTrendData(chartData)

  return (
    <div className='rounded-2xl border border-[var(--border)] bg-[var(--bg-card)] p-5 shadow-sm'>
      <div className='mb-4'>
        <div className='flex items-center gap-2'>
          <TrendingUp size={16} className='text-accent' aria-hidden />
          <h3 className='text-base font-semibold text-text-primary'>Entrada mensal</h3>
        </div>
        <p className='mt-1 text-sm text-text-muted'>Novos leads na carteira closer por mês</p>
      </div>

      {hasData ? (
        <ResponsiveContainer width='100%' height={240}>
          <BarChart data={chartData}>
            <CartesianGrid strokeDasharray='3 3' stroke='var(--border)' vertical={false} />
            <XAxis
              dataKey='month'
              tick={{ fill: 'var(--font-color-muted)', fontSize: 12 }}
              axisLine={false}
              tickLine={false}
            />
            <YAxis
              allowDecimals={false}
              tick={{ fill: 'var(--font-color-muted)', fontSize: 11 }}
              axisLine={false}
              tickLine={false}
              width={32}
            />
            <Tooltip
              contentStyle={{
                backgroundColor: 'var(--bg-card)',
                border: '1px solid var(--border)',
                borderRadius: '12px',
              }}
              formatter={(value) => [
                formatDashboardNumber(Number(value ?? 0), valuesVisible),
                'Leads',
              ]}
            />
            <Bar
              dataKey='leads'
              fill='var(--brand-primary)'
              radius={[6, 6, 0, 0]}
              maxBarSize={48}
              isAnimationActive={!reduced}
            />
          </BarChart>
        </ResponsiveContainer>
      ) : (
        <div className='flex h-[240px] flex-col items-center justify-center gap-2 px-4 text-center'>
          <p className='text-sm font-medium text-text-primary'>Sem entradas no período</p>
          <p className='text-sm text-text-muted'>Amplie o filtro de datas para ver a tendência.</p>
        </div>
      )}
    </div>
  )
}
